export interface IBusiness {
  code: string;
  description: string;
}

export const Business: IBusiness[] = [
  {
    code: '01',
    description: 'Accounting/Finance'
  },
  {
    code: '02',
    description: 'Casino/Other types of gaming/gambling operations'
  },
  {
    code: '03',
    description: 'Consulting'
  },
  {
    code: '04',
    description: 'Engineering'
  },
  {
    code: '05',
    description: 'Executive/Management'
  },
  {
    code: '06',
    description: 'Government/Military'
  },
  {
    code: '07',
    description: 'Involved in production/distribution of military products'
  },
  {
    code: '08',
    description: 'Money Service Business'
  },
  {
    code: '09',
    description: 'Professional Services'
  },
   {
    code: '10',
    description: 'Research & Development'
  },
   {
    code: '11',
    description: 'Sales/Marketing/Advertising'
  },
   {
    code: '12',
    description: 'Others'
  },
]


